import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-chart-bar_fill",
  "use": "rt-portal-chart-bar_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-chart-bar_fill\">\n<path d=\"M804.2,96H219.8C152.7,96,96,152.7,96,219.8v584.4C96,871.3,152.7,928,219.8,928h584.4c67.1,0,123.8-56.7,123.8-123.8V219.8\n\tC928,152.7,871.3,96,804.2,96z M372,716.6c0,13.2-10.8,24-24,24h-56c-13.2,0-24-10.8-24-24V535.4c0-28.7,23.3-52,52-52\n\ts52,23.3,52,52V716.6z M564,716.6c0,13.2-10.8,24-24,24h-56c-13.2,0-24-10.8-24-24V335.4c0-28.7,23.3-52,52-52s52,23.3,52,52V716.6z\n\t M756,716.6c0,13.2-10.8,24-24,24h-56c-13.2,0-24-10.8-24-24V465.4c0-28.7,23.3-52,52-52s52,23.3,52,52V716.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/chart-bar_fill.svg
// module id = 1257
// module chunks = 116